<template>
  <div class="w100 Overview">
    <div class="search-top" v-loading="Loading">
      <div>
        <el-select
          v-model="searchData.SupplierId"
          filterable
          clearable
          style="width: 260px"
          placeholder="请选择供应商"
        >
          <el-option
            v-for="item in SupplierData"
            :key="item.Id"
            :label="item.title"
            :value="item.Id"
          ></el-option>
        </el-select>
        <el-input
          style="width: 260px; margin-left: 10px"
          clearable
          v-model="searchData.Device"
          placeholder="请输入设备名称/编号"
        ></el-input>
        <el-select
          v-model="searchData.InforType"
          filterable
          clearable
          placeholder="请选择文件类型"
          style="width: 260px; margin-left: 10px"
        >
          <el-option
            v-for="item in DeviceTypeList"
            :key="item.Id"
            :label="item.DicName"
            :value="item.DicName"
          ></el-option>
        </el-select>
        <el-input
          style="width: 260px; margin-left: 10px"
          v-model="searchData.InforName"
          clearable
          placeholder="请输入文件名称"
        ></el-input>
        <el-button type="primary" style="margin-left: 10px" @click="getDataList"
          >查询</el-button
        >
      </div>
      <!-- <div style="">
        <span class="Quantity">文件数量小计：{{ TotalQuantity }}</span>
        <span class="Quantity">文件数量总计：{{ SumQuantity }}</span>
      </div> -->
    </div>
    <el-table
      class="table-ove"
      :data="Data"
      style="width: 100%"
      header-row-class-name="table-tit"
      v-loading="Loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column prop="DeviceCode" label="设备编号" align="center" />
      <el-table-column prop="DeviceName" label="设备名称" align="center" />
      <el-table-column prop="SupplierName" label="供应商名称" align="center" />

      <el-table-column prop="InforType" label="文件类型" align="center" />
      <el-table-column
        prop="InforName"
        label="文件名称"
        align="center"
        width="360"
      >
        <template slot-scope="scope">
          <!-- <el-button type="text" size="mini" @click="handleClick(scope.row)">{{
            scope.row.InforName
          }}</el-button> -->
          <a
            :href="scope.row.InforUrl"
            target="_blank"
            style="color: #409eff"
            >{{ scope.row.InforName }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="InforTime"
        label="提交时间"
        align="center"
        width="160"
        :formatter="
          (row, column, cellValue) =>
            cellValue ? moment(cellValue).format('YYYY-MM-DD HH:mm:ss') : ''
        "
      />
    </el-table>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      Loading: false,
      Data: [],
      searchData: {
        SupplierName: '',
        InforType: '',
        InforName: '',
        Device: '',
        SupplierId: '',
      },
      DeviceTypeList: [],
      SupplierData: [],
    }
  },
  props: {
    pId: {
      type: String,
      default: '',
    },
  },
  components: {},
  methods: {
    getDeviceTypeList() {
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'DeviceDocumentType',
        })
        .then((res) => {
          if (res.Success) {
            this.DeviceTypeList = res.Data || []
          }
        })
    },
    getSupplierData() {
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'ProjectSupplierTree',
          ProjectId: this.pId,
        })
        .then((res) => {
          if (res.Success) {
            this.SupplierData = res.Data
          }
        })
    },
    handleClick(row) {
      window.open(row.InforUrl)
    },
    rowName(obj) {
      if (obj.row.Leve == 1) {
        return 'level1'
      }
    },
    getDataList() {
      this.Loading = true
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'DeviceInforList',
          ProjectId: this.pId,
          ...this.searchData,
        })
        .then((res) => {
          this.Loading = false
          if (res.Success) {
            this.Data = res.Data || []
          }
        })
    },

    createGaugeChart(containerId, value, color) {
      const container = document.getElementById(containerId)
      if (!container) return

      const chart = echarts.init(container)
      const option = {
        series: [
          {
            type: 'gauge',

            min: 0,
            max: 100,
            //分割数
            splitNumber: 5,
            radius: '90%',
            center: ['50%', '50%'],
            progress: {
              show: true,
              width: 6,
              itemStyle: {
                color: color,
              },
              roundCap: true,
            },
            axisLine: {
              lineStyle: {
                width: 6,
              },
            },
            // 刻度样式。
            axisTick: {
              show: true,
              distance: 1,
              length: 1,
              lineStyle: {
                width: 1,
                color: '#999',
              },
            },
            splitLine: {
              distance: 1,
              show: true,
              length: 0,
              lineStyle: {
                width: 1,
                color: '#999',
              },
            },
            axisLabel: {
              distance: 7,
              color: '#999',
              fontSize: 8,
            },
            pointer: {
              width: 3,
              length: '70%',
              itemStyle: {
                color: color,
              },
            },
            detail: {
              formatter: '{value}%',
              textStyle: {
                fontSize: 12,
                color: '#333',
              },
              offsetCenter: [0, 12],
            },
            data: [
              {
                value: value || 0,
              },
            ],
          },
        ],
      }

      chart.setOption(option)
      chart.resize()
    },
  },
  mounted() {
    // this.initCharts()
  },
  created() {
    this.getDeviceTypeList()
    this.getSupplierData()
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .table-tit {
  font-weight: 1000;
  font-size: 16px;
  color: #000;
  height: 40px;
}
.table-ove {
  margin-bottom: 20px;
}
.Overview {
  padding: 0 10px;
}
::v-deep .el-table__body-wrapper {
  .el-table__cell {
    font-size: 14px;
  }
}
::v-deep .level1 {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}
</style>
